/** Holders are the platform's investment entities; the prototype's registry records sit under /sample. */
export const entityPath = (entityId: string) => `/manager/holders/${encodeURIComponent(entityId)}`;

export const SAMPLE_HOLDERS_PATH = '/manager/holders/sample';

export const sampleHolderPath = (holderId: string) => `${SAMPLE_HOLDERS_PATH}/${holderId}`;
